import React, { useState, useEffect } from 'react'
import {
    Box,
    Button,
    IconButton,
    TextField,
    Typography,
} from '@mui/material'
import { AddCircleOutline, Delete } from '@mui/icons-material'

interface CustomTableProps {
    data: any;
    onDataChange: (newData: { fetch_roles: any[]; custom_roles: any }, user_roles?: any) => void;
}

const SEND_EMAIL: React.FC<CustomTableProps> = ({ data, onDataChange }) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    const parseInitialEmails = (raw: string | null) => {
        if (!raw) return ['']
        return raw.split(',').map(email => email.trim()).filter(e => e !== '')
    }

    const initialEmails = parseInitialEmails(data?.details || '')
    const [emails, setEmails] = useState<string[]>(initialEmails.length > 0 ? initialEmails : [''])
    const [emailErrors, setEmailErrors] = useState<boolean[]>(initialEmails.map(email => !emailRegex.test(email)))
    const [note, setNote] = useState('')

    // useEffect(() => {
    //     const validEmails = emails.filter((email, i) => {
    //         return email.trim() !== '' && !emailErrors[i]
    //     })
    //     const emailString = validEmails.join(',')
    //     onDataChange({ ...data, emails: emailString, message: note })
    // }, [emails, emailErrors])

    useEffect(() => {
        const emailString = getValidEmailsString(emails, emailRegex)
        onDataChange({ ...data, emails: emailString, message: note })
    }, [emails, emailErrors,note])


    const getValidEmailsString = (emails: string[], emailRegex: RegExp): string => {
        const hasInvalid = emails.some(email => email.trim() !== '' && !emailRegex.test(email.trim()))
        if (hasInvalid) return ""
        return emails
            .map(email => email.trim())
            .filter(email => email !== '')
            .join(',')
    }


    const validateEmail = (email: string) => {
        return email.trim() === '' || emailRegex.test(email)
    }

    const updateEmail = (index: number, value: string) => {
        const newEmails = [...emails]
        const newErrors = [...emailErrors]

        newEmails[index] = value
        setEmails(newEmails)

        setTimeout(() => {
            newErrors[index] = value.trim() !== '' && !validateEmail(value)
            setEmailErrors(newErrors)
        }, 300)
    }

    const addEmailField = () => {
        setEmails([...emails, ''])
        setEmailErrors([...emailErrors, false])
    }

    const removeEmailField = (index: number) => {
        if (emails.length > 1) {
            const newEmails = [...emails]
            const newErrors = [...emailErrors]
            newEmails.splice(index, 1)
            newErrors.splice(index, 1)
            setEmails(newEmails)
            setEmailErrors(newErrors)
        }
    }

    return (
        <Box sx={{ width: "100%", mx: 'auto' }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Correos Electrónicos
            </Typography>

            {emails.map((email, index) => (
                <Box key={index} display="flex" flexDirection="column" gap={1} mb={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <TextField
                            fullWidth
                            type="email"
                            placeholder="correo@ejemplo.com"
                            value={email}
                            onChange={(e) => updateEmail(index, e.target.value)}
                            variant="outlined"
                            size="medium"
                            error={emailErrors[index]}
                            helperText={emailErrors[index] ? 'Formato inválido' : ''}
                            InputProps={{
                                sx: {
                                    borderRadius: 2,
                                },
                            }}
                        />
                        <IconButton
                            onClick={() => removeEmailField(index)}
                            disabled={emails.length === 1}
                        >
                            <Delete />
                        </IconButton>
                    </Box>
                </Box>
            ))}

            <Button
                type="button"
                onClick={addEmailField}
                variant="outlined"
                fullWidth
                startIcon={<AddCircleOutline />}
                sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    mb: 2,
                }}
            >
                Agregar otro correo
            </Button>

            <Box>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Nota Adicional
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Escriba su nota aquí..."
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    variant="outlined"
                    InputProps={{
                        sx: {
                            borderRadius: 2,
                        },
                    }}
                />
            </Box>
        </Box>
    )
}

export default SEND_EMAIL
